import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IAddresses } from '../../../pages/profile/profile';

import './locationsFilters.scss';

interface ILocationsFilter {
  addresses: IAddresses[] | undefined;
  onChange: (event: any) => void;
  address?: any;
}

const LocationsFilters: React.FC<ILocationsFilter> = ({ addresses, onChange, address }) => {
  return <div className='location-filter-wrapper'>
    <DropDownList data={addresses} onChange={onChange} textField="label" dataItemKey={'id'} value={address} />
  </div>;
};

export default LocationsFilters;
